import { createMysqlFamilyConnector } from './mysql';

export default createMysqlFamilyConnector({
	id: 'mariadb',
	name: '$t:connectors.mariadb.name',
	description: '$t:connectors.mariadb.description',
	icon: 'simple-icons:mariadb',
	iconBackground: '#003545',
	iconForeground: '#FFFFFF',
	defaultPort: 3306,
	connectionStringPlaceholder: 'mariadb://user:password@host:3306/database',
	connectionStringProtocols: ['mariadb:', 'mysql:'],
	keywords: ['mariadb', 'maria'],
});
